// extracted by mini-css-extract-plugin
export default {"main":"NoMatchPage_main__0ywH4","text":"NoMatchPage_text__4UcQj","link":"NoMatchPage_link__TVb2g"};